import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { DialogsStore } from 'stores';
import { ForcedChoiceModal, StaleSession } from '.';
import { FlightsActionType } from '__generated__/api';

interface DialogsProps {
  dialogsStore?: DialogsStore;
  dialogType: string;
  handleActionSelection?: (actionType: FlightsActionType) => void;
}

export const Dialogs = inject('dialogsStore')(
  observer(({ dialogsStore, dialogType, handleActionSelection }: DialogsProps) => (
    <>
      {dialogsStore.dialogs &&
        dialogsStore.dialogs.map(dialog => {
          if (dialog.__typename === dialogType) {
            switch (dialog.__typename) {
              case 'FlightsDialogStaleSession':
                return <StaleSession key={`dialog-${dialog.__typename}`} staleSession={dialog} />;
              case 'FlightsDialogForcedChoiceLodgingCrossSell':
                return (
                  <ForcedChoiceModal
                    key={`dialog-${dialog.__typename}`}
                    dialogForcedChoiceLodgingCrossSell={dialog}
                    handleActionSelection={handleActionSelection}
                  />
                );
              default:
            }
          }
        })}
    </>
  ))
);
